var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionPrefillFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2c1.383 0 2.684.262 3.9.787a10.106 10.106 0 013.175 2.138c.9.9 1.612 1.958 2.137 3.175A9.735 9.735 0 0122 12c0 .454-.031.899-.088 1.335a5.5 5.5 0 00-7.073 8.259A9.913 9.913 0 0112 22a9.735 9.735 0 01-3.9-.788 10.091 10.091 0 01-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.734 9.734 0 012 12c0-1.383.263-2.684.788-3.9a10.092 10.092 0 012.137-3.175c.9-.9 1.958-1.613 3.175-2.138A9.745 9.745 0 0112 2zm-1 9.6l-3.7 3.7 1.4 1.4 4.3-4.3V7h-2v4.6z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.223 15.26c.19.085.371.19.539.311l1.327-.22.75 1.298-.855 1.04a3.053 3.053 0 010 .622l.855 1.04-.75 1.298-1.327-.22a2.996 2.996 0 01-.54.311L19.75 22h-1.5l-.473-1.26a2.996 2.996 0 01-.539-.311l-1.327.22-.75-1.298.855-1.04a3.053 3.053 0 010-.622l-.855-1.04.75-1.298 1.327.22a3 3 0 01.54-.311L18.25 14h1.5l.473 1.26zM19 17a1 1 0 100 2 1 1 0 000-2z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionPrefillFill);
export default __webpack_public_path__ + "bf5a132dd92ddd555f70b9ccb42bbeea.svg";
export { ForwardRef as ReactComponent };